export enum TelegramAuthStatus {
    StartChannel = "StartChannel",
    EmptySettings = "EmptySettings",
    Error = "Error",
    Initializing = "Initializing",
    WaitingForScan = "WaitingForScan",
    Authorized = "Authorized",
    RequiresPassword = "RequiresPassword",
    RequiresManualInput = "RequiresManualInput"
}